import { useCallback, useState, type ChangeEvent } from "react";
import {
  MultiKeyInstrument,
  getAllInstruments,
  getMultiKeyInstrumentById,
} from "../utils/sampleUtils";

export const useInstrumentSelection = (initialInstrument: MultiKeyInstrument) => {
  const [currentInstrument, setCurrentInstrument] =
    useState<MultiKeyInstrument>(initialInstrument);

  const setInstrumentById = useCallback((instrumentId: string) => {
    const instrument = getMultiKeyInstrumentById(instrumentId);
    if (instrument) {
      setCurrentInstrument(instrument);
    }
  }, []);

  const handleInstrumentChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      setInstrumentById(event.target.value);
    },
    [setInstrumentById],
  );

  const handlePreviousInstrument = useCallback(() => {
    const instruments = getAllInstruments();
    const currentIndex = instruments.findIndex(
      (instrument) => instrument.id === currentInstrument.id,
    );
    if (currentIndex > 0) {
      setInstrumentById(instruments[currentIndex - 1].id);
    }
  }, [currentInstrument.id, setInstrumentById]);

  const handleNextInstrument = useCallback(() => {
    const instruments = getAllInstruments();
    const currentIndex = instruments.findIndex(
      (instrument) => instrument.id === currentInstrument.id,
    );
    if (currentIndex < instruments.length - 1) {
      setInstrumentById(instruments[currentIndex + 1].id);
    }
  }, [currentInstrument.id, setInstrumentById]);

  const handleShuffle = useCallback(() => {
    const instruments = getAllInstruments();
    const randomIndex = Math.floor(Math.random() * instruments.length);
    setInstrumentById(instruments[randomIndex].id);
  }, [setInstrumentById]);

  return {
    currentInstrument,
    setInstrumentById,
    handleInstrumentChange,
    handlePreviousInstrument,
    handleNextInstrument,
    handleShuffle,
  };
};
